import axios from 'axios'

const advisor = { 
  getAdvisorSettings: () => axios.get( 
    `${process.env.REACT_APP_API_URL}advisor/AdvisorSettings` 
  ).then(res => res.data),
  postAdvisorSettings:  (data) => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/AdvisorSettings`, data
  ).then( res => res.data ),
  getClients: () => axios.get( 
    `${process.env.REACT_APP_API_URL}advisor/Clients` 
  ).then(res => res.data),
  getClient: () => axios.get( 
    `${process.env.REACT_APP_API_URL}advisor/Client` 
  ).then(res => res.data),
  searchClients: (query) => axios.get(
    `${process.env.REACT_APP_API_URL}advisor/Clients?filter=${query}`
  ).then(res => res.data),
  getClientRestorePoint: () => axios.get( 
    `${process.env.REACT_APP_API_URL}advisor/RestorePoint` 
  ).then(res => res.data), 
  getClientPlans: () => axios.get(
    `${process.env.REACT_APP_API_URL}advisor/Plans`
  ).then(res => res.data),
  selectPlan: data => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/SelectPlan?id=${data}`
  ).then( res => res.data ),     
  editPlan: data => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/EditPlan`, data
  ).then( res => res.data ),     
  planAction: action => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/PlanAction?action=${action}`
  ).then( res => res.data ), 
  deletePlan: data => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/DeletePlan?id=${data}`
  ).then( res => res.data ),
  closeClient: () => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/CloseClient`
  ).then( res => res.data ),
  postClient: data => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/Client`, data
    ).then( res => res.data ),    
  patchClient: data => axios.patch(
    `${process.env.REACT_APP_API_URL}advisor/Client`, data
  ).then( res => res.data ),    
  sendInvite: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/SendInvite`, data
  ).then( res => res.data ),      
  previewInvite: () => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/CreateInvite`
  ).then( res => res.data ),  
  drawDown: (id, year) => axios.get(
    `${process.env.REACT_APP_API_URL}advisor/DrawDown?planID=${id}&year=${year}`
  ).then( res => res.data ),    
  updateYear: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/UpdateYear`, data
  ).then( res => res.data ),    
  updateNote: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/UpdateNote`, data
  ).then( res => res.data ),
  getSettings: (id) => axios.get(
    `${process.env.REACT_APP_API_URL}advisor/DrawdownSettings?id=${id}`
  ).then( res => res.data),
  updateSettings: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/DrawdownSettings`, data
  ).then( res => res.data ),
  getAdvisorDetails: () => axios.get(
    `${process.env.REACT_APP_API_URL}advisor/AdvisorDetails`
  ).then( res => res.data),
  saveAdvisorDetails: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/AdvisorDetails`, data
  ).then( res => res.data ),
  getRollover: () => axios.get(
    `${process.env.REACT_APP_API_URL}advisor/Rollover`
  ).then( res => res.data),
  processRollover: (actionID) => axios.post(
    `${process.env.REACT_APP_API_URL}advisor/ProcessRollover?actionID=${actionID}`
  ).then( res => res.data), 
} 

export default advisor